import { observable } from "mobx";
import EnforcementUserType from "./enforcementUserType";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class EnforcementTabletUserSearchRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  /**
   * Number of records to be skipped before selecting records.
   * @example
   * 1
   */
  @observable
  offset?: number;

  /**
   * User ID.
   */
  id?: string;

  /**
   * User personal code.
   */
  @observable
  code?: string;

  @observable
  userType?: EnforcementUserType;

  /**
   * Indicates if user is manager.
   */
  @observable
  isManager?: boolean;
}

export const EnforcementUserSearchValidationRules: EntityValidationRules<EnforcementTabletUserSearchRequest> = {
  code: {
    isLength: {
      max: 25,
      optional: true,
    },
  },
  id: {
    isLength: {
      min: 32,
      max: 36,
      optional: true,
    },
  },
};
